var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tinymce',{attrs:{"value":_vm.formModel[_vm.field],"disabled":_vm.options['disabled']},on:{"input":_vm.input}})
}
var staticRenderFns = []

export { render, staticRenderFns }